"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useControllableState = void 0;
var react_1 = require("react");
var useCallbackRef = function (callback) {
    var callbackRef = (0, react_1.useRef)(callback);
    (0, react_1.useEffect)(function () {
        callbackRef.current = callback;
    });
    return (0, react_1.useMemo)(function () { return (function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = callbackRef.current) === null || _a === void 0 ? void 0 : _a.call.apply(_a, __spreadArray([callbackRef], args, false));
    }); }, []);
};
var useUncontrolledState = function (_a) {
    var defaultValue = _a.defaultValue, onChange = _a.onChange;
    var uncontrolledState = (0, react_1.useState)(defaultValue);
    var value = uncontrolledState[0];
    var prevValueRef = (0, react_1.useRef)(value);
    var handleChange = useCallbackRef(onChange);
    (0, react_1.useEffect)(function () {
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [value, handleChange]);
    return uncontrolledState;
};
var useControllableState = function (_a) {
    var defaultValue = _a.defaultValue, onChange = _a.onChange, value = _a.value;
    var _b = useUncontrolledState({
        defaultValue: defaultValue,
        onChange: onChange
    }), uncontrolledValue = _b[0], setUncontrolledValue = _b[1];
    var isControlled = value !== undefined;
    var internalValue = isControlled ? value : uncontrolledValue;
    var handleChange = useCallbackRef(onChange);
    var setValue = (0, react_1.useCallback)(function (nextValue) {
        if (isControlled) {
            var setter = nextValue;
            var _value = typeof nextValue === 'function' ? setter(value) : nextValue;
            if (_value !== value)
                handleChange(_value);
        }
        else {
            setUncontrolledValue(nextValue);
        }
    }, [isControlled, value, handleChange, setUncontrolledValue]);
    return [internalValue, setValue];
};
exports.useControllableState = useControllableState;
